var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.47203 12.2423L7.52922 13.1851C6.22748 14.4868 4.11693 14.4868 2.81518 13.1851C1.51343 11.8834 1.51343 9.7728 2.81518 8.47106L3.75799 7.52825M12.2433 8.47106L13.1861 7.52825C14.4878 6.2265 14.4878 4.11595 13.1861 2.8142C11.8843 1.51245 9.77378 1.51245 8.47203 2.8142L7.52922 3.75701M5.66729 10.333L10.334 5.6663",
    stroke: "#24B956",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.4753dc6847870aff3896292418596b00.svg";
export { ForwardRef as ReactComponent };